import { X } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { LOGO_URL } from "@/lib/ebook";

const NAV = [
  { label: "Home", to: "/" },
  { label: "The Experiences", to: "/#experiences" },
  { label: "Royal Essence", to: "/collection/royal-essence" },
  { label: "Sovereign Canvas", to: "/collection/sovereign" },
  { label: "Majestic Vibes", to: "/collection/majestic-vibes" },
  { label: "Free Photo Guide", to: "/ebook" },
  { label: "How It Works", to: "/how-it-works" },
  { label: "Black Excellence Unveiled", to: "/black-excellence-unveiled" },
  { label: "Our Story", to: "/#our-story" },
  { label: "Contact", to: "/contact" },
];

export default function MobileMenu({ open, onClose }) {
  const { pathname } = useLocation();
  if (!open) return null;
  return (
    <div data-testid="mobile-menu" className="fixed inset-0 z-[80] bg-[#080808]/97 backdrop-blur-xl animate-in fade-in duration-300 overflow-y-auto">
      <div className="flex items-center justify-between px-5 py-3 border-b border-white/10">
        <Link to="/" onClick={onClose} className="flex items-center">
          <img src={LOGO_URL} alt="Crowned Canvas Creations — official logo" className="h-14 w-auto object-contain" />
        </Link>
        <button onClick={onClose} data-testid="mobile-menu-close" className="w-10 h-10 flex items-center justify-center text-white/70 hover:text-[#D4AF37]" aria-label="Close menu">
          <X className="w-5 h-5" />
        </button>
      </div>
      <nav className="px-6 py-8 flex flex-col gap-1" aria-label="Mobile">
        {NAV.map((n) => {
          const active = pathname === n.to.split("#")[0] && !n.to.includes("#");
          return (
            <Link
              key={n.label}
              to={n.to}
              onClick={onClose}
              data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s|&/g, "-")}`}
              className={`font-serif-display text-xl py-3 border-b border-white/5 ${active ? "text-[#D4AF37]" : "text-white"} hover:text-[#D4AF37] transition-colors`}
            >
              {n.label}
            </Link>
          );
        })}
        <Link
          to="/#experiences"
          onClick={onClose}
          data-testid="mobile-cta-book"
          className="mt-8 inline-flex items-center justify-center bg-[#D4AF37] text-[#080808] px-7 py-4 text-xs uppercase tracking-[0.22em] font-semibold hover:bg-[#e6c245] transition-all"
        >
          Create Your Masterpiece
        </Link>
      </nav>
    </div>
  );
}
